<a
  (click)="logout()"
  mat-stroked-button
  color="primary"
  class="w-100">Logout</a>
